<template>
    <div v-if="formattedBatteryPercentage" class="installation-overview-battery-icon-container">
        <img :src="batteryIconImageSource" class="image-battery-icon" />
        <span v-if="isCharging" class="sg-vrm-icon_150_charging-5px ev-card"></span>
        <div
            :class="[
                'battery-percentage-text-container',
                { dashboard: isDashboard, charging: isDashboard && isCharging },
            ]"
        >
            <span class="battery-percentage-text">{{ formattedBatteryPercentage }}</span>
        </div>
        <div
            :class="['battery-indicator-rectangle', { zero: isLowBattery }]"
            :style="{ width: batteryIndicatorWidth + 'px' }"
        ></div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject, AngularDirective } from '@/vue/decorators/angular-interop';
@Component
@AngularDirective('vrm-battery-icon-installation-overview')
export default class VrmBatteryIconInstallationOverview extends Vue {
    @ngInject()
    AppearanceService;
    @Prop()
    batteryPercentage;
    @Prop()
    isDashboard;
    @Prop()
    isCharging;

    get isLowBattery() {
        if (this.floatBatteryPercentage == null) return false;

        return this.isDashboard
            ? this.floatBatteryPercentage <= 20
            : this.floatBatteryPercentage === 0;
    }

    get formattedBatteryPercentage() {
        if (!this.batteryPercentage) return null;
        // Remove any spaces from the battery percentage string
        let formattedPercentage = this.batteryPercentage.replace(/\s+/g, '');
        // If the battery percentage ends with ".0%", remove the ".0" for cleaner output
        if (formattedPercentage && formattedPercentage.endsWith('.0%')) {
            formattedPercentage = formattedPercentage.slice(0, -3) + '%'; // Remove ".0" from the percentage
        }
        return formattedPercentage;
    }

    /**
     * Converts the formatted battery percentage string (e.g., "95%") to a float value (e.g., 95.0).
     */
    get floatBatteryPercentage() {
        if (!this.formattedBatteryPercentage) return null;

        const stringWithoutPercent = this.formattedBatteryPercentage.replace('%', '');
        return parseFloat(stringWithoutPercent);
    }

    get batteryIconImageSource() {
        if (this.isLowBattery) {
            return this.AppearanceService.isDarkModeActive()
                ? 'img/battery-icon-installation-overview-has-no-battery-dark.svg'
                : 'img/battery-icon-installation-overview-has-no-battery.svg';
        } else {
            return this.AppearanceService.isDarkModeActive()
                ? 'img/battery-icon-installation-overview-has-battery-dark.svg'
                : 'img/battery-icon-installation-overview-has-battery.svg';
        }
    }

    /**Returns the width of the battery indicator depending on the percentage value of the battery remaining.
       Max-width(full-battery) = 32px
       Min-width(1% battery) = 2px 
    **/
    get batteryIndicatorWidth() {
        //If battery is 0, the design requires the inner rectangle to display full battery width but a different color
        if (this.floatBatteryPercentage === 0) {
            return 32;
        }

        //The minimum value is 2 since the borders themselves are 0.2 rem(2px)
        const minValue = 2;

        //The step is calculated by dividing the range from 2 to 32 into 100 equal step progressions to represent
        //each integer change in percentage.
        const step = 0.303;

        // For example, at 2.7% battery:
        // - The formula will compute: 2 + (Floor(2.7 - 1) * 0.303) = 2 + (1 * 0.303) = 2.303px
        // This ensures the battery indicator width is dynamically adjusted based on the current percentage.
        const calculatedWidth = minValue + Math.floor(this.floatBatteryPercentage - 1) * step;
        return parseFloat(calculatedWidth.toFixed(2));
    }
}
</script>
